import { useState, useEffect } from 'react'
import { IncentivePlanAuditEntry } from '../../../../../apis/types'
import { getIncentivePlanAuditHistoryApi } from '../../../../../apis/apis'

interface UseIncentivePlanAuditHistoryResult {
    auditHistory: IncentivePlanAuditEntry[]
    isLoading: boolean
    error: string | null
}

export function useIncentivePlanAuditHistory(
    tenantAccountId: string,
    planCuid: string
): UseIncentivePlanAuditHistoryResult {
    const [auditHistory, setAuditHistory] = useState<IncentivePlanAuditEntry[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        if (!tenantAccountId || !planCuid) return

        let cancelled = false
        setIsLoading(true)
        setError(null)

        getIncentivePlanAuditHistoryApi(tenantAccountId, planCuid)
            .then((data) => {
                if (!cancelled) setAuditHistory(data)
            })
            .catch(() => {
                if (!cancelled) setError('Failed to load activity log')
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false)
            })

        return () => {
            cancelled = true
        }
    }, [tenantAccountId, planCuid])

    return { auditHistory, isLoading, error }
}
